import {DEFAULT_HOST} from '@/utils/router'

export const getTrademarkDisputesContent = () => ({
  metaTitle: 'trademark-disputes.ip-cases-meta-title',
  metaDescription: 'trademark-disputes.ip-cases-meta-description',
  breadcrumbLabel: 'trademark-disputes.ip-cases-breadcrumb-label',
  ogImage: {
    url: `${DEFAULT_HOST}/images/og-images/trademark-disputes-en.png`,
    width: 1200,
    height: 627,
    alt: 'Trademark disputes - OG image',
  },
  hero: {
    title: 'trademark-disputes.ip-cases-hero-title',
    subtitle: 'trademark-disputes.ip-cases-hero-subtitle',
    imageSrc: '/images/hero/drawer-with-documents.svg',
    imageAlt: 'Drawer with documents',
  },
  searchTitle: 'trademark-disputes.ip-cases-search-title',
  searchPlaceholder: 'start-typing-title',
  noResultsTitle: 'no-results-found',
  browseCasesTitle: 'trademark-disputes.browse-cases-title',
  byJurisdictionTitle: 'trademark-disputes.by-jurisdiction-title',
  byIndustryTitle: 'trademark-disputes.by-industry-title',
  bySubjectMatterTitle: 'trademark-disputes.by-subject-matter-title',
  byJudicialPartyTitle: 'trademark-disputes.by-judicial-party-title',
  viewAllButton: 'view-all-title',
  selectedCasesTitle: 'trademark-disputes.selected-cases-title',
  subjectMatterTitle: 'subject-matter-title',
  jurisdiction: {
    general: {
      metaTitle: 'trademark-disputes.ip-cases-by-jurisdiction-meta-title',
      metaDescription: 'trademark-disputes.ip-cases-by-jurisdiction-meta-description',
      heroTitle: 'trademark-disputes.ip-cases-by-jurisdiction-hero-title',
      listTitle: 'trademark-disputes.select-jurisdiction-title',
    },
    selected: {
      metaTitle: 'trademark-disputes.ip-cases-by-selected-jurisdiction-meta-title',
      metaDescription: 'trademark-disputes.ip-cases-by-selected-jurisdiction-meta-description',
      heroTitle: 'trademark-disputes.ip-cases-by-selected-jurisdiction-hero-title',
    },
  },
  industry: {
    general: {
      metaTitle: 'trademark-disputes.ip-cases-by-industry-meta-title',
      metaDescription: 'trademark-disputes.ip-cases-by-industry-meta-description',
      heroTitle: 'trademark-disputes.ip-cases-by-industry-hero-title',
      listTitle: 'trademark-disputes.select-industry-title',
    },
    selected: {
      metaTitle: 'trademark-disputes.ip-cases-by-selected-industry-meta-title',
      metaDescription: 'trademark-disputes.ip-cases-by-selected-industry-meta-description',
      heroTitle: 'trademark-disputes.ip-cases-by-selected-industry-hero-title',
    },
  },
  subjectMatter: {
    general: {
      metaTitle: 'trademark-disputes.ip-cases-by-subject-matter-meta-title',
      metaDescription: 'trademark-disputes.ip-cases-by-subject-matter-meta-description',
      heroTitle: 'trademark-disputes.ip-cases-by-subject-matter-hero-title',
      listTitle: 'trademark-disputes.select-subject-matter-title',
    },
    selected: {
      metaTitle: 'trademark-disputes.ip-cases-by-selected-subject-matter-meta-title',
      metaDescription: 'trademark-disputes.ip-cases-by-selected-subject-matter-meta-description',
      heroTitle: 'trademark-disputes.ip-cases-by-selected-subject-matter-hero-title',
    },
  },
  judicialParty: {
    general: {
      metaTitle: 'trademark-disputes.ip-cases-by-judicial-party-meta-title',
      metaDescription: 'trademark-disputes.ip-cases-by-judicial-party-meta-description',
      heroTitle: 'trademark-disputes.ip-cases-by-judicial-party-hero-title',
      listTitle: 'trademark-disputes.select-judicial-party-title',
    },
    selected: {
      metaTitle: 'trademark-disputes.ip-cases-by-selected-judicial-party-meta-title',
      metaDescription: 'trademark-disputes.ip-cases-by-selected-judicial-party-meta-description',
      heroTitle: 'trademark-disputes.ip-cases-by-selected-judicial-party-hero-title',
    },
  },
  ipCase: {
    metaTitle: 'trademark-disputes.ip-cases-selected-case-meta-title',
    metaDescription: 'trademark-disputes.ip-cases-selected-case-meta-description',
  },
  ipCasesFaqTitle: 'trademark-disputes.ip-cases-faq-title',
  caseDetailsTitle: 'trademark-disputes.case-details-title',
  plaintiffTitle: 'trademark-disputes.plaintiff-title',
  defendantTitle: 'trademark-disputes.defendant-title',
  caseNumberTitle: 'trademark-disputes.case-number-title',
  jurisdictionTitle: 'jurisdiction-title',
  industryTitle: 'industry-title',
  decisionDateTitle: 'trademark-disputes.decision-date-title',
  decisionTitle: 'decision-title',
  comparisonOfTrademarksTitle: 'trademark-disputes.comparison-of-trademarks-title',
  relatedCasesTitle: 'trademark-disputes.related-cases-title',
  relatedArticlesTitle: 'related-articles-title',
})
